import React from 'react';

import { useHistory } from 'react-router-dom';

import DataValidation from 'containers/GlobalWrapper/DataValidation';
import { useLastVisitedPage } from 'utils/localStorageUser';
import { redirectAfterLogin } from 'utils/redirect-utils';

const RootRedirect = () => {
  const [page] = useLastVisitedPage();
  const history = useHistory();

  return <DataValidation onValidationSuccess={() => redirectAfterLogin(history, page)} />;
};

export default RootRedirect;
